import type { FC } from 'react';
import { getTestProps } from '@mwl/marker-tree';
import { Button } from '@/components/Button/Button';
import { FilterMainTitle } from '../FilterMainTitle/FilterMainTitle';
import type { FilterButtonProps } from './FilterMobileButton.types';
import styles from './FilterMobileButton.module.scss';
export const FilterMobileButton: FC<FilterButtonProps> = ({
  selectedAmount,
  onFilterClick,
  analytics,
  className,
  title,
  isFilterOpen,
  ...props
}) => {
  return <Button {...getTestProps(props)} as="button" className={cn(styles.root, styles.filterButton, className, {
    [styles.isSelectedItems]: !!selectedAmount
  })} onClick={onFilterClick} analytics={analytics} color={isFilterOpen ? 'grey' : 'black-light'} data-sentry-element="Button" data-sentry-component="FilterMobileButton" data-sentry-source-file="FilterMobileButton.tsx">
      <FilterMainTitle isMobile selectedNumber={selectedAmount} title={title} classes={{
      title: !isFilterOpen ? styles.title : undefined
    }} data-sentry-element="FilterMainTitle" data-sentry-source-file="FilterMobileButton.tsx" />
    </Button>;
};
export * from './FilterMobileButton.types';